document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-carousel]").forEach((carousel) => {
    const track = carousel.querySelector(".hero-carousel__track");
    const slides = carousel.querySelectorAll(".hero-carousel__slide");
    const dots = carousel.querySelectorAll(".hero-carousel__dot");
    const speed = (carousel.dataset.speed || 5) * 1000;

    let index = 0;
    let interval;
    let isPaused = false;
    let startX = 0;
    let currentTranslate = 0;

    function update() {
      track.style.transform = `translateX(-${index * 100}%)`;
      dots.forEach(dot => dot.classList.remove("active"));
      if (dots[index]) dots[index].classList.add("active");
    }

    function nextSlide() {
      index = (index + 1) % slides.length;
      update();
    }

    function startAutoplay() {
      interval = setInterval(() => {
        if (!isPaused) nextSlide();
      }, speed);
    }

    function stopAutoplay() {
      clearInterval(interval);
    }

    // Dots click
    dots.forEach(dot => {
      dot.addEventListener("click", () => {
        index = parseInt(dot.dataset.index);
        update();
      });
    });

    // Pause on interaction
    carousel.addEventListener("mouseenter", () => isPaused = true);
    carousel.addEventListener("mouseleave", () => isPaused = false);
    carousel.addEventListener("focusin", () => isPaused = true);
    carousel.addEventListener("focusout", () => isPaused = false);

    // Swipe
    carousel.addEventListener("touchstart", e => {
      isPaused = true;
      startX = e.touches[0].clientX;
    });

    carousel.addEventListener("touchend", e => {
      const diff = e.changedTouches[0].clientX - startX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) {
          index = (index - 1 + slides.length) % slides.length;
        } else {
          nextSlide();
        }
        update();
      }
      isPaused = false;
    });

    update();
    startAutoplay();
  });
});
